import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from '../core/http.service';
import { GlobalsService } from '../globals.service';
import { Advertiser } from 'src/app/models/services/audiences/tiktok/advertiser';
import { Observable, of } from 'rxjs';
import { Business } from 'src/app/models/services/audiences/tiktok/business';
import { Audience } from 'src/app/models/services/audiences/tiktok/audience';

@Injectable({
  providedIn: 'root'
})
export class TikTokAudiencesService {

  constructor(
    private httpService: HttpService,
    private globalsService: GlobalsService
  ) { }

  public getBusiness(): Observable<Business[]> {
    let url: string = `${environment.audiencesServicesApiBaseUri}/target-platforms/tiktok/business`;
    return this.httpService.get(url, this.globalsService.getActiveCompany()?.id);
  }

  public getAdvertisers(businessId: string): Observable<Advertiser[]> {
    let url: string = `${environment.audiencesServicesApiBaseUri}/target-platforms/tiktok/business/${businessId}/advertisers`;
    return this.httpService.get(url, this.globalsService.getActiveCompany()?.id);
  }

  public getAudiences(advertiserId: string): Observable<Audience[]> {
    let url: string = `${environment.audiencesServicesApiBaseUri}/target-platforms/tiktok/business/advertisers/${advertiserId}/audiences`;
    return this.httpService.get(url, this.globalsService.getActiveCompany()?.id);
  } 

}